import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

interface ifeildType {
  id: string;
  option_name: string;
}

const AutocompleteMuiCustom = ({
  id,
  option_name,
  onChange,
  option_name_2,
  value,
  arrayofObj,
  label,
  style,
  ...rest
}: {
  id: string;
  value: string | {};
  option_name: string;
  arrayofObj: [] | any;
  label?: string;
  style?: any;
  sx?: any;
  variant?: 'standard';
  option_name_2?: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, value?: any) => void;
}) => {
  return (
    <>
      <Autocomplete
        style={style}
        id={id}
        options={arrayofObj}
        getOptionLabel={(option: any) =>
          // option_name_2
          //   ? `${option?.[option_name] || ''} ${option?.[option_name_2] || ''}`
          //   : option?.[option_name] || ''
          option[option_name]
            ? `${option?.[option_name]} ${(option_name_2 && ' - ') || ''} ${
                typeof option?.[option_name_2] === 'object'
                  ? option?.[option_name_2]?.part_name
                  : option?.[option_name_2] || ''
              }`
            : ''
        }
        isOptionEqualToValue={(option: any, value: any) =>
          option?.[option_name] === value?.[option_name] || true
        }
        value={value}
        onChange={(e: any, value) => onChange(e, value)}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
            }}
            label={label}
            {...rest}
          />
        )}
      />
    </>
  );
};

export default AutocompleteMuiCustom;
